import { Link } from "react-router-dom"
import { Facebook, Instagram, Twitter, Linkedin, Mail, MapPin, Phone, Clock } from "lucide-react"

const Footer = () => {
  return (
    <footer
      className="text-black mb-[60px] md:mb-0"
      style={{ backgroundColor: "#B8B8B8" }}
    >    
      <div className="container mx-auto px-4 py-12 md:py-16">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1 - About */}
          <div>
            <div className="mb-6">
              <img src="/MAMS-Logo.png" alt="MAMS Hospitals Logo" className="h-14 w-auto" />
            </div>
            <p className="text-black mb-4">
              At MAMS Hospitals, we're committed to providing accessible, quality healthcare with compassion and
              excellence.
            </p>
            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.facebook.com/MAMSHospitals"
                aria-label="Visit MAMS Hospitals Facebook page"
                title="Facebook"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-[#096256] transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>

              <a
                href="https://x.com/MAMSHospitals"
                aria-label="Visit MAMS Hospitals X page"
                title="X"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-[#096256] transition-colors"
              >
                <Twitter className="h-5 w-5" />
              </a>

              <a
                href="https://www.instagram.com/mams_hospitals/"
                aria-label="Visit MAMS Hospitals Instagram page"
                title="Instagram"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-[#096256] transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>

              <a
                href="https://www.linkedin.com/company/mamshospitals"
                aria-label="Visit MAMS Hospitals LinkedIn page"
                title="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-[#096256] transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Column 2 - Departments */}
          <div>
            <div className="text-lg font-medium mb-6 text-black">Departments</div>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/departments/cardiology"
                  className="text-black hover:text-[#096256] transition-colors"
                >
                  Cardiology
                </Link>
              </li>
              <li>
                <Link
                  to="/departments/neurology"
                  className="text-black hover:text-[#096256] transition-colors"
                >
                  Neurology
                </Link>
              </li>
              <li>
                <Link
                  to="/departments/orthopedics"
                  className="text-black hover:text-[#096256] transition-colors"
                >
                  Orthopaedics
                </Link>
              </li>
              <li>
                <Link
                  to="/departments/pediatrics"
                  className="text-black hover:text-[#096256] transition-colors"
                >
                  Paediatrics
                </Link>
              </li>
              <li>
                <Link to="/departments" className="text-black hover:text-[#096256] transition-colors">
                  View All Departments
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Quick Links */}
          <div>
            <div className="text-lg font-medium mb-6 text-black">Quick Links</div>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-black hover:text-[#096256] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/doctors" className="text-black hover:text-[#096256] transition-colors">
                  Our Doctors
                </Link>
              </li>
              <li>
                <Link to="/departments" className="text-black hover:text-[#096256] transition-colors">
                  Our Departments
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-black hover:text-[#096256] transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                {/* <Link to="/privacy-policy" className="text-black hover:text-[#096256] transition-colors">
                  Privacy Policy
                </Link> */}
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <div className="text-lg font-medium mb-6 text-black">Contact Us</div>
            <ul className="space-y-4">
              <li className="flex">
                <MapPin className="h-5 w-5 mr-3 text-[#096256]" />

                <span className="text-black">Bachupally, Hyderabad, Telangana – 500090</span>
              </li>
              <li className="flex">
                <a href="tel:7399999981" title="phone"><Phone className="h-6 w-6 text-[#096256] hidden md:block" /></a>
                <span className="text-black"> +91-7399999981</span>
              </li>
              {/* <li className="flex">
                <Mail className="h-5 w-5 mr-3 text-apple-teal" />
                <span className="text-black">info@mamshospitals.com</span>
              </li> */}
              <li className="flex">
                <Clock className="h-5 w-5 mr-3 text-[#096256]" />
                <div className="text-black">
                  <p>Broad Specialties: 9:00 AM – 5:00 PM</p>
                  <p>Super Specialties: 10:00 AM – 4:00 PM</p>
                  <p>Emergency: 24/7</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-500 mt-10 pt-6 text-center text-black text-sm">
          <p>&copy; {new Date().getFullYear()} MAMS Hospitals. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
